import SecurityIcon from '@material-ui/icons/Security';
import {
  createFrontendPlugin,
  createRouteRef,
  PageBlueprint,
} from '@backstage/frontend-plugin-api';

const rootRouteRef = createRouteRef();

const secretScanPage = PageBlueprint.make({
  params: {
    path: '/seguranca/segredos',
    routeRef: rootRouteRef,
    loader: () =>
      import('./SecretScanPage').then(module => <module.SecretScanPage />),
  },
});

export const secretScanPlugin = createFrontendPlugin({
  pluginId: 'secret-scan',
  title: 'Segredos nos Repositórios',
  icon: <SecurityIcon />,
  routes: { root: rootRouteRef },
  extensions: [secretScanPage],
});
